/**
 * ChatChannelMemberGetReq 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * ChatChannelMemberGetReq
 */
export interface ChatChannelMemberGetReq {
  /** 成员记录ID，多个ID用逗号分隔 */
  id: string
}

/**
 * ChatChannelMemberGetReq Schema
 */
export const ChatChannelMemberGetReqSchema: SchemaDefinition = {
  properties: {
    id: {
      description: '成员记录ID，多个ID用逗号分隔',
      format: 'string',
      type: 'string',
      label: '成员记录ID',
    },
  },
  required: ['id'],
  type: 'object',
}
